"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _constants = require("../../../constants");
var _context = require("../../../context");
var _enums = require("../../../types/enums");
var _icons = require("../../icons");
var _tooltipContent = require("../tooltip-content.css");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const BuildErrorTooltipContent = () => {
  var _buildInfo$siteInfo, _buildInfo$siteInfo2;
  const {
    buildInfo,
    currentBuildId,
    trackEvent
  } = (0, _react.useContext)(_context.IndicatorContext);
  const buildLogUrl = (0, _react.useMemo)(() => {
    let pathToBuildLogs = ``;
    if (currentBuildId || buildInfo !== null && buildInfo !== void 0 && buildInfo.siteInfo) {
      const {
        orgId,
        siteId
      } = buildInfo.siteInfo;
      if (!currentBuildId) {
        pathToBuildLogs = `https://www.gatsbyjs.com/dashboard/${orgId}/sites/${siteId}/cmsPreview`;
      } else {
        pathToBuildLogs = `https://www.gatsbyjs.com/dashboard/${orgId}/sites/${siteId}/builds/${currentBuildId}/details`;
      }
      const returnTo = encodeURIComponent(pathToBuildLogs);
      return `${pathToBuildLogs}?returnTo=${returnTo}`;
    }
    return pathToBuildLogs;
  }, [buildInfo === null || buildInfo === void 0 ? void 0 : (_buildInfo$siteInfo = buildInfo.siteInfo) === null || _buildInfo$siteInfo === void 0 ? void 0 : _buildInfo$siteInfo.orgId, buildInfo === null || buildInfo === void 0 ? void 0 : (_buildInfo$siteInfo2 = buildInfo.siteInfo) === null || _buildInfo$siteInfo2 === void 0 ? void 0 : _buildInfo$siteInfo2.siteId, currentBuildId]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, _icons.failedIcon, (buildInfo === null || buildInfo === void 0 ? void 0 : buildInfo.errorMessage) || _constants.messages.unableToBuildPreview, /*#__PURE__*/_react.default.createElement("a", {
    href: buildLogUrl,
    target: "_blank",
    rel: "noreferrer",
    onClick: () => {
      trackEvent({
        eventType: _enums.EventType.PREVIEW_INDICATOR_CLICK,
        name: `error logs`
      });
    },
    className: _tooltipContent.linkWrapperStyle
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: _tooltipContent.linkTextStyle
  }, _constants.messages.viewLogs), _icons.logsIcon));
};
var _default = BuildErrorTooltipContent;
exports.default = _default;